import { useContext } from 'react';
import { NavigationContext } from '../../NavigationContext';
import { useCurrentLocation } from '../../hooks/useCurrentLocation';

export enum Variant {
  BILLING = 'billing',
  OTR = 'otr',
  ONE_ID_REVENUE = 'one_id_revenue',
  UNKNOWN = 'unknown',
}

export const useVariant = () => {
  const { variant } = useContext(NavigationContext);
  const { host } = useCurrentLocation();
  const isOneIDEnvironment = host.startsWith('one');

  if (variant === 'billing') {
    return Variant.BILLING;
  }
  if (variant === 'revenue') {
    if (isOneIDEnvironment) {
      return Variant.ONE_ID_REVENUE;
    } else {
      return Variant.OTR;
    }
  }
  return Variant.UNKNOWN;
};
